export default "__VITE_ASSET__CMHP4qaB__"